import React from 'react';

const TableHeader  = props => {
    
    return <th>{props.headerTitle}</th>;
};

export default TableHeader;